export default __webpack_public_path__ + "static/media/Void Warden.706c3ee9.jpg";